const FCM_DATABASE_NAME = 'firebase-messaging-database';
const FCM_OBJECT_STORE_NAME = 'firebase-messaging-store';

let messaging = undefined;

/*
 * Can't use runtime env (resource/env.js) since need to be in sync with
 * resource/fcmServiceWorker.js
 *
 */
const projectId = process.env.PROJECT_ID;
const config = {
  apiKey: process.env.FCM_API_KEY,
  authDomain: `${projectId}.firebaseapp.com`,
  databaseURL: `https://${projectId}.firebaseio.com`,
  projectId: projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId: process.env.FCM_SENDER_ID,
  appId: process.env.FCM_APP_ID,
};

const initFcm = async () => {
  const [{ initializeApp }, { getMessaging }] = await Promise.all([
    import('firebase/app'),
    import('firebase/messaging'),
  ]);
  const app = initializeApp(config);
  messaging = getMessaging(app);
};

const getFcmToken = async () => {
  if (!messaging) return;
  const { getToken } = await import('firebase/messaging');
  const options = {};

  if (!messaging.vapidKey) options.vapidKey = process.env.FCM_PUBLIC_VAPID_KEY;

  await navigator.serviceWorker.ready;
  const registration = await navigator.serviceWorker.getRegistration();

  if (registration && registration?.pushManager) {
    options.serviceWorkerRegistration = registration;
    return getToken(messaging, options);
  }
};

const deleteFcmToken = async () => {
  if (!messaging) return;
  const { deleteToken } = await import('firebase/messaging');

  // set swRegistration for messaging to ensure that we can delete token and unsubscribe push notification every time
  if (!messaging.swRegistration) {
    await navigator.serviceWorker.ready;
    const registration = await navigator.serviceWorker.getRegistration();
    messaging.swRegistration = registration;
  }

  try {
    await deleteToken(messaging);
    // eslint-disable-next-line no-empty
  } catch (_) {
  } finally {
    // always clear the fcm messaging indexedDB to make sure get the new token
    const { default: localforage } = await import('localforage');
    try {
      const store = await localforage.createInstance({
        name: FCM_DATABASE_NAME,
        storeName: FCM_OBJECT_STORE_NAME,
      });
      await store.clear();
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
};

const getFcmMessaging = () => messaging;

export { initFcm, getFcmMessaging, getFcmToken, deleteFcmToken };
